
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("2Efzn", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $1edb64fe4a0d55db$export$2cd8252107eb640b; });

var $2mpqL = parcelRequire("2mpqL");

var $5PBbn = parcelRequire("5PBbn");
const $1edb64fe4a0d55db$var$adjustContainer = (cID)=>{
    let container = document.querySelector(`#${cID}`);
    let wWidth = window.innerWidth;
    if (wWidth > 575) {
        let pAddOffset = 0;
        if (wWidth >= 991 && wWidth < 1400) pAddOffset = 45;
        else if (wWidth >= 1400) pAddOffset = 65;
        let combinedOffset = 80 + pAddOffset;
        let containerOffset = (wWidth - container.offsetWidth) / 2 - 80;
        if (containerOffset < 0) containerOffset = 0;
        container.style.paddingLeft = `${combinedOffset}px`;
        container.style.paddingRight = `${combinedOffset}px`;
        container.style.marginLeft = `${containerOffset}px`;
        container.style.marginRight = 0;
        container.style.maxWidth = `calc(100% - ${containerOffset}px)`;
    } else container.removeAttribute("style");
};
const $1edb64fe4a0d55db$export$2cd8252107eb640b = function(callback) {
    let swiperContainers = document.querySelectorAll(".swiper-container--5");
    swiperContainers.forEach(function(swiperContainer) {
        let cID = swiperContainer.getAttribute("id");
        let id = swiperContainer.querySelector(".swiper").getAttribute("id");
        let cSlider = document.querySelector(`#${cID} .content-slider--5`);
        let swiper = new (0, $2mpqL.default)(`#${id}`, {
            modules: [
                (0, $5PBbn.Navigation),
                (0, $5PBbn.Keyboard),
                (0, $5PBbn.A11y),
                (0, $5PBbn.Pagination)
            ],
            speed: 500,
            rewind: true,
            slidesOffsetAfter: 0,
            slidesPerView: "auto",
            watchSlidesProgress: true,
            pagination: {
                el: `#${cID} .swiper-pagination`,
                clickable: true
            },
            keyboard: {
                enabled: true
            },
            a11y: {
                enabled: true
            },
            breakpoints: {
                768: {
                    slidesOffsetAfter: 90
                },
                991: {
                    slidesOffsetAfter: 0
                }
            },
            on: {
                afterInit: function() {
                    document.querySelector(`#${cID}`).classList.add("slider-init");
                    cSlider.classList.add("slider-initialized");
                },
                lock: function(swiper) {
                    document.querySelector(`#${cID}`).classList.add("slider-lock");
                    cSlider.style.paddingBottom = "0";
                },
                unlock: function(swiper) {
                    document.querySelector(`#${cID}`).classList.remove("slider-lock");
                    cSlider.removeAttribute("style");
                }
            }
        });
        document.querySelector(`#${cID} .arrow--next`).addEventListener("click", function() {
            swiper.slideNext();
        });
        document.querySelector(`#${cID} .arrow--prev`).addEventListener("click", function() {
            swiper.slidePrev();
        });
        $1edb64fe4a0d55db$var$adjustContainer(cID);
        window.addEventListener("resize", function() {
            $1edb64fe4a0d55db$var$adjustContainer(cID);
        });
    });
};

});

parcelRegister("jHMUv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e587f90d126edbfb$export$581ff339ea0ba762; });

var $5gKb4 = parcelRequire("5gKb4");
function $e587f90d126edbfb$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5gKb4._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("5gKb4", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $3d624443cd99befe$export$1e71eb4bef00f6b0; });
function $3d624443cd99befe$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hYccX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d15182816097eec3$export$4fa2f4023c9cbda5; });
function $d15182816097eec3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d15182816097eec3$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d15182816097eec3$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=slider5.swiper.module.6048654a.js.map
